import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PrimengModule } from '../global/primeng.module';
import { SharedModule } from '../shared/shared.module';

import { DropdownInvestorGroupComponent } from './dropdown-investor-group/dropdown-investor-group.component';

@NgModule({
  declarations: [
    DropdownInvestorGroupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    PrimengModule
  ],
  exports: [DropdownInvestorGroupComponent]
})
export class InvestorModule { }
